import * as React from 'react';

export default () => {
  return (
    <div className="font-sans antialiased flex flex-grow application-offset">
      <div className="flex-1 flex flex-col">{/*<Main service={service}/>*/}</div>
    </div>
  );
};
